import React from "react";
import Course from "../components/CourseDetails/Course";
import ConditionalLayout from "../layout/ConditionalLayout";

const OnlineCourseDetail = () => {
  return (
    <ConditionalLayout showFooter={false} isVideo>
      <Course />
    </ConditionalLayout>
  );
};

export default OnlineCourseDetail;
